import React from 'react';
import CustomLazyLoadImage from '../Image/CustomLazyLoadImage';

interface CustomizableGPSIconProps {
    centerImage: string; // URL to the custom center image
    size: number; // Size of the entire SVG icon
}

const GPSIconWithUser: React.FC<CustomizableGPSIconProps> = ({ centerImage, size }) => {
    const circleStyle: React.CSSProperties = {
        width: size + 'px',
        height: size + 'px',
        borderRadius: '50%',
        overflow: 'hidden',
        position: 'relative',
    };

    const imageStyle: React.CSSProperties = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    };

    return (
        <div style={circleStyle}>
            <div
                style={{
                    position: 'absolute',
                    top: '14px',
                    left: '25px',
                    width: size * 0.5,
                    height: size * 0.5,
                    borderRadius: size,
                    overflow: 'hidden',
                    border: `4px solid #fff`,
                }}>
                <CustomLazyLoadImage src={centerImage} alt="Center" style={imageStyle} />
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48">
                <path
                    fill="none"
                    stroke="#fff"
                    strokeWidth="2px"
                    fillRule="evenodd"
                    d="M41,18c0,11-17,29-17,29S7,29,7,18C7,8.06,14.06,1,24,1S41,8.06,41,18Z"
                />
            </svg>
        </div>
    );
};

export { GPSIconWithUser };
